module.exports = __webpack_public_path__ + "media/images/nav/icon_11-9db0e3fe1bc403a95e1f7a31d82cce9e.svg";